import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import config from '../../config/config';
import {
  LEGAL_NOTICES_PATH,
  TERMS_OF_USE_PATH
} from './../../config/routes';
import { useResto } from '../../contexts/RestoContext';

const FooterLinks = () => {
  const { t } = useTranslation();
  const { restoData } = useResto();

  const logoUrl = (restoData && restoData.hasLogo ) 
  ? `${config.documentsUrl}logos/logo_resized.png` 
  : `${config.kubuniImagesUrl}mon-petit-resto/logos/logo_resized.png`;

  return (
    <div id="footer-links" className="text-center background-main-color-80" style={{ color: 'rgb(255,255,255)' }}>

        { restoData && restoData.hasLogo && restoData.hasFooterLogo && <img src={logoUrl} alt="Logo" height="140" style={{ margin: '20px auto'}} /> }      

        <p style={{margin: 0}}><Link to={LEGAL_NOTICES_PATH} className="text-reset text-decoration-none text-decoration-underline-hover">{ t('LEGAL_NOTICES') }</Link></p>
        <p><Link to={TERMS_OF_USE_PATH} className="text-reset text-decoration-none text-decoration-underline-hover">{ t('TERMS_OF_USE') }</Link></p>
    </div>
  );
}

export default FooterLinks;
